import * as Sentry from '@sentry/browser'

import { CONFIG } from './configSentry'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: CONFIG.sentryWebsiteDns,
        replaysOnErrorSampleRate: 0.1, // 1.0 for testing purposes 0.1 ideal for production.
        sendDefaultPii: true,
        integrations: [
            Sentry.breadcrumbsIntegration({
                console: true,
                dom: true,
                fetch: true,
                history: true,
                xhr: true,
            }),
            Sentry.replayIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.browserSessionIntegration(),
            Sentry.browserTracingIntegration(),
            Sentry.contextLinesIntegration(),
            Sentry.extraErrorDataIntegration(),
            Sentry.httpClientIntegration(),
            Sentry.moduleMetadataIntegration(),
            Sentry.replayCanvasIntegration(),
        ],
    })
}
